module.exports = __webpack_public_path__ + "components/country-flag/static/to-97585102c2949086edc09479a384ab13.svg";